/* [PATCH nastavitve-zavihki v1] skupni gumb "Nazaj na nadzorno plosco".
   [PATCH ozadje-po-sekciji v1] slog = aktiven zavihek Sifrantov (gumb "Partnerji"). */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function NazajGumb() {
  const navigate = useNavigate();
  return (
    <button onClick={() => navigate('/nadzorna')} /* [PATCH aplikacije-fe v1] nadzorna plosca je /nadzorna; '/' je izbira aplikacije */
      className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium border bg-blue-600 text-white border-blue-600 hover:bg-blue-700 transition">
      <ArrowLeft className="w-4 h-4" />
      <span>Nazaj na nadzorno ploščo</span>
    </button>
  );
}
